<template>
  <div class="ma-4">
    <monthly-amount-dialog
      ref="finance"
      :clientID="clientID"
      @message-dialog="messageDialog"
      :financeItemData="$store.state.finances.items"
      @get-finance="getFinance"
    />

    <CloseOutDialog
      @get-finance="getFinance"
      :clientID="clientID"
      :financeItemData="$store.state.finances.items"
      :financeID="financeID"
      @initialized="initialized"
    />

    <v-snackbar v-model="msg" top>
      {{ text }}
      <v-btn color="pink" text @click="msg = false"> Close</v-btn></v-snackbar
    >
    <ClientNav />
    <v-row dense>
      <v-progress-linear
        v-model="value"
        :active="show"
        :indeterminate="query"
        :query="true"
        color="cyan"
      ></v-progress-linear>
      <v-col cols="12" lg="3" xl="2">
        <ClientSide />
      </v-col>
      <v-col cols="12" lg="9" xl="10">
        <v-row dense>
          <v-col cols="12" md="8" sm="12">
            <v-card elevation="0" outlined min-height="490">
              <v-card-title class="mx-2">Balance</v-card-title>
              <v-divider class="mx-2"></v-divider>
              <v-container>
                <v-row dense class="mt-3 mb-2">
                  <v-col cols="12" md="6">
                    <v-card
                      class="d-flex justify-space-between pa-2"
                      outlined
                      rounded="lg"
                      color="#8C000D"
                    >
                      <div d-flex class="pa-3 ml-2">
                        <div>
                          <h3 class="font-weight-medium white--text">EBT</h3>
                          <span class="display-1 white--text">
                            ${{ dashboard.EBT || initalValue }}
                          </span>
                          <br />
                          <span class="white--text font-weight-thin caption">
                            {{ dashboard.Date || "" }}
                          </span>
                        </div>
                      </div>
                      <div class="align-self-center mr-5">
                        <v-icon large color="white" style="font-size: 50px">
                          mdi-credit-card-multiple
                        </v-icon>
                      </div>
                    </v-card>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-card
                      class="d-flex justify-space-between pa-2"
                      outlined
                      rounded="lg"
                      color="#0B3866"
                    >
                      <div d-flex class="pa-3 ml-2">
                        <div>
                          <h3 class="font-weight-medium white--text">
                            Debit Card
                          </h3>
                          <span class="display-1 white--text">
                            ${{ dashboard.DebitCard || initalValue }}
                          </span>
                          <br />
                          <span class="white--text font-weight-thin caption">
                            {{ dashboard.Date || "" }}
                          </span>
                        </div>
                      </div>
                      <div class="align-self-center mr-5">
                        <v-icon large color="white" style="font-size: 50px">
                          mdi-credit-card-multiple
                        </v-icon>
                      </div>
                    </v-card>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-card
                      class="d-flex justify-space-between pa-2"
                      outlined
                      rounded="lg"
                      color="#52A65E"
                    >
                      <div d-flex class="pa-3 ml-2">
                        <div>
                          <h3 class="font-weight-medium white--text">Cash</h3>
                          <span class="display-1 white--text">
                            ${{ dashboard.Cash || initalValue }}</span
                          >
                          <br />
                          <span class="white--text font-weight-thin caption">
                            {{ dashboard.Date || "" }}
                          </span>
                        </div>
                      </div>
                      <div class="align-self-center mr-5">
                        <v-icon large color="white" style="font-size: 50px">
                          mdi-credit-card-multiple
                        </v-icon>
                      </div>
                    </v-card>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-card
                      class="d-flex justify-space-between pa-2"
                      outlined
                      rounded="lg"
                      color="#1E81AC"
                    >
                      <div d-flex class="pa-3 ml-2">
                        <div>
                          <h3 class="font-weight-medium white--text">
                            Expenses
                          </h3>
                          <span class="display-1 white--text">
                            ${{ dashboard.Expense || initalValue }}</span
                          >
                          <br />
                          <span class="white--text font-weight-thin caption">
                            {{ dashboard.Date || "" }}
                          </span>
                        </div>
                      </div>
                      <div class="align-self-center mr-5">
                        <v-icon large color="white" style="font-size: 50px">
                          mdi-credit-card-multiple
                        </v-icon>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>

              <v-divider class="mx-2"></v-divider>
              <v-row align="center" justify="end" class="mx-2 my-2">
                <span class="mr-10"> Total Balance </span>
                <span
                  class="ml-10 mr-2 green--text font-weight-bold balance-amount--current"
                >
                  ${{ dashboard.Total || initalValue }}
                </span>
              </v-row>
            </v-card>
          </v-col>

          <latest-transactions :latest-transactions="latestTransactions" />
        </v-row>

        <v-row dense>
          <v-col cols="12" md="12">
            <v-card elevation="0" outlined>
              <v-data-table
                :headers="headers"
                :items="finances"
                :item-class="rowColor"
                class="mt-4"
                sort-by="Date"
                sort-desc
                loading-text="Loading Finances"
                :search="search"
                height="475"
                :loading="isLoading"
              >
                <template v-slot:item.select="{ item }">
                  <router-link
                    :to="{
                      name: 'Transaction History',
                      params: { clientID: item.ClientID },
                      query: { financeID: item._id, type: 'Debit Card' },
                    }"
                  >
                    <v-btn
                      x-small
                      class="white--text"
                      color="#2b3990"
                      @click="setCloseOut(item.CloseOut)"
                    >
                      select
                    </v-btn>
                  </router-link>
                </template>



                <template v-slot:item.CloseOut="{ item }">
                  <v-chip small :color="item.CloseOut ? 'red' : 'green'" dark>
                    {{ item.CloseOut ? "Closed" : "Open" }}
                  </v-chip>
                </template>

                <template v-slot:top>
                  <v-toolbar flat color="white">
                    <v-toolbar-title>Client Finances</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                    <v-text-field
                      v-model="search"
                      clearable
                      flat
                      solo-inverted
                      hide-details
                      prepend-inner-icon="search"
                      label="search"
                      class="desktop"
                    ></v-text-field>
                    <v-spacer></v-spacer>

                    <!-- Finances Dialog -->

                    <v-btn
                      v-if="!isAuditorRole"
                      color="#2b3990"
                      dark
                      class="mb-2 mt-2"
                      @click="showAdd()"
                    >
                      <v-icon left>add</v-icon>
                      Create Monthly Register</v-btn
                    >
                  </v-toolbar>
                  <v-text-field
                    v-model="search"
                    clearable
                    flat
                    solo-inverted
                    hide-details
                    prepend-inner-icon="search"
                    label="search"
                    class="mobile ml-5 mr-5 mb-3 mt-3"
                  ></v-text-field>
                </template>
                <template v-slot:item.ClientSignature="{ item }">
                  <v-img
                    max-height="80"
                    max-width="150"
                    :src="item.ClientSignature"
                  ></v-img>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-icon
                    small
                    class="mr-2"
                    @click="
                      viewFinance(item);
                      $event.stopPropagation();
                    "
                  >
                    mdi-eye
                  </v-icon>
                  <!--
                  <v-icon
                    small
                    class="mr-2"
                    @click="
                      closeOut(item._id);
                      $event.stopPropagation();
                    "
                  >
                    mdi-transfer
                  </v-icon>
                  -->
                  <v-icon
                    small
                    @click="
                      deleteFinance(item._id);
                      $event.stopPropagation();
                    "
                    v-if="isAdmin"
                  >
                    mdi-delete
                  </v-icon>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <Foot />
  </div>
</template>

<script>
/*eslint-disable */
import axios from "axios";
import ClientNav from "@/components/ClientNav";
import ClientSide from "@/components/ClientSide";
import Foot from "@/components/Footer";
import MonthlyAmountDialog from "@/components/finances/MonthlyAmountDialog";
import LatestTransactions from "@/components/finances/LatestTransactions";
import CloseOutDialog from "@/components/finances/CloseOutDialog";
import { mapMutations, mapActions, mapState, mapGetters } from "vuex";
import { setUserTz, tz } from "../../../utils/timezone";

const url = require("../../client_config/config").url;

export default {
  components: {
    ClientNav,
    ClientSide,
    MonthlyAmountDialog,
    LatestTransactions,
    CloseOutDialog,
    Foot,
  },
  data: function () {
    return {
      headers: [
        {
          text: "Select",
          align: "start",
          sortable: false,
          value: "select",
        },
        { text: "Date", value: "Date" },
        { text: "Month", value: "Month" },
        { text: "($)Balance", value: "roundBalance" },
        { text: "Staff Signature", value: "StaffSignature", width: "200px" },
        { text: "Status", value: "CloseOut" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      value: 0,
      query: false,
      show: true,
      interval: 0,
      staff: "",
      signed: false,
      dialog: false,
      transactionDialog: false,
      editFinance: false,
      newFinance: false,
      msg: false,
      search: "",
      text: "",
      finances: [],
      filteredFinances: [],
      clientID: this.$route.params.clientID,
      userID: "",
      tempData: [],
      titleForm: "New Finance",
      financeID: "",
      newDate: "",
      newAction: "",
      newTransactionMethods: "",
      newAmount: "",
      newPayee: "",
      newExpenseCategory: "",
      newPurchaseLocation: "",
      newDepositCategory: "",
      newNotes: "",
      newSignature: "",
      newClientSignature: "",
      signaturepop2: false,
      newBalance: 0,
      newSigned: "",
      newReceipt: "",
      newReceiptImage: "",
      editedIndex: -1,
      uploadImg: "",
      transactionMethodItems: [
        { id: "1", item: "EBT" },
        { id: "2", item: "Cash" },
        { id: "3", item: "Debit Card" },
      ],
      isAdmin: false,
      selectedTransactionMethod: [],
      editedItem: {
        date: "",
        action: "",
        transactionMethods: "",
        amount: "",
        payee: "",
        expenseCategory: "",
        purchaseLocation: "",
        depositCategory: "",
        notes: "",
        signature: "",
        clientSignature: "",
        signed: "",
        balance: "",
      },
      defaultItem: {
        date: "",
        action: "",
        transactionMethods: "",
        amount: "",
        payee: "",
        expenseCategory: "",
        purchaseLocation: "",
        depositCategory: "",
        notes: "",
        signature: "",
        clientSignature: "",
        signed: "",
        balance: "",
      },
      action: ["Expense", "Deposit"],
      transactionMethods: ["Cash", "Debit Card", "EBT"],
      categories: [
        "Food",
        "Fast Food",
        "Personal Care",
        "Automotive",
        "Fuel",
        "Cigarettes",
        "Alcohol",
        "Entertainment",
        "Gifts",
        "Charity",
        "Bank Fee's",
        "Medical",
        "Dental",
        "Insurance",
        "Rent",
        "Utilities",
        "Phone",
        "Other",
      ],
      depositCategories: ["Benefits", "Wages", "Interests", "Other"],
      selectedFinanceItem: "",
      deposit: 0,
      expense: 0,
      EBT: 0,
      creditCard: 0,
      total: 0,
      financesData: [],
      AllfinancesData: [],
      latestTransactions: [],
      initalValue: parseFloat(0).toFixed(2),
      isLoading: false,
    };
  },

  mounted() {
    this.queryAndIndeterminate();
  },

  beforeDestroy() {
    clearInterval(this.interval);
  },

  created() {
    this.userID = localStorage.getItem("userID");
    if (localStorage.getItem("userRole") == "Administration") {
      this.isAdmin = true;
    }
    this.initialized();
  },

  computed: {
    ...mapGetters({
      getUserTimezone: "timezones/getUserTimezone",
      getDefaultTz: "timezones/getDefaultTz",
      getLatestTransactions: "financeTransactions/getLatestTransactions",
    }),

    ...mapState({
      dashboard: (state) => state.finances.dashboard,
    }),

    userTimezone() {
      const data = {
        userTimezone: this.getUserTimezone,
        defaultTz: this.getDefaultTz,
      };
      return setUserTz(data);
    },

    formTitle() {
      return this.editedIndex != 1 ? "New Item" : "Edit Item";
    },
    isAuditorRole() {
      return localStorage.getItem("userRole") === 'Auditor'
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  methods: {
   initialized() {
      this.getDashboardData(this.clientID);
      this.getFinanceTransactions();
      this.getFinanceItem()
    },
    queryAndIndeterminate() {
      this.query = true;
      this.value = 0;

      setTimeout(() => {
        this.query = false;

        this.interval = setInterval(() => {
          if (this.value === 100) {
            clearInterval(this.interval);
            this.show = false;
            return setTimeout(this.queryAndIndeterminate, 1000);
          }
          this.value += 25;
        }, 1000);
      }, 2000);
    },

    ...mapActions({
      getClientFinances: "finances/getClientFinances",
      getDashboardData: "finances/getDashboardData",
      deleteItem: "finances/deleteItem",
      getFinanceLatestTransactions:
        "financeTransactions/getFinanceLatestTransactions",
    }),

    ...mapMutations({
      setMonthlyAmountDialog: "finances/SET_MONTHLY_AMOUNT_DIALOG",
      setCloseOut: "finances/SET_CLOSEOUT",
    }),

    viewFinance(item) {
      this.$refs.finance.onViewItem(item);
      this.setMonthlyAmountDialog(true);
      this.getClientFinances(this.clientID);
    },
    showAdd() {
      this.setMonthlyAmountDialog(true);
    },

    async getFinanceItem(){
      this.isLoading = true;
      try {
        const response = await this.getClientFinances(this.clientID);
        this.finances = response
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false;
      }
    },

    clear() {
      this.newDate = "";
      this.newAction = "";
      this.newTransactionMethods = "";
      this.newAmount = "";
      this.newPayee = "";
      this.newExpenseCategory = "";
      this.newPurchaseLocation = "";
      this.newDepositCategory = "";
      this.newNotes = "";
      this.newSignature = "";
      this.newClientSignature = "";
      this.newBalance =
        this.finances.length < 1
          ? 0
          : parseInt(this.finances[this.finances.length - 1].Balance);
      this.newReceipt = "";
      this.newSigned = "";
      this.newReceiptImage = "";
    },

    close() {
      this.dialog = false;
      this.clear();
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    rowColor(item) {
      if (item.TransactionMethods === "Cash") {
        return "green lighten-5";
      }

      if (item.TransactionMethods === "Debit Card") {
        return "blue lighten-5";
      }

      if (item.TransactionMethods === "EBT") {
        return "red lighten-5";
      }
    },

    async getFinanceTransactions() {
      const transaction = await this.getFinanceLatestTransactions(
        this.clientID
      );

      let setTransactionTz = transaction.map((item) => {
        return {
          ...item,
          createdAt: tz(item.createdAt, this.userTimezone).format(
            "MM/DD/YYYY h:mma"
          ),
        };
      });

      this.latestTransactions = this.insertIntoArray(setTransactionTz, {
        divider: true,
        inset: true,
      });
    },

    insertIntoArray(arr, value) {
      // adding divider into finance transaction array
      return arr.reduce((result, element, index, array) => {
        result.push(element);
        if (index < array.length - 1) {
          result.push(value);
        }
        return result;
      }, []);
    },

    getUsers: function () {
      axios.get(`${url}/users`).then(async (res) => {
        this.users = res.data.users;
        for (var i = 0; i < this.users.length; i++) {
          if (this.userID == this.users[i]._id) {
            this.staff = this.users[i].Name;
          }
        }
      });
    },

    messageDialog(item) {
      this.msg = item.msg;
      this.text = item.text;
    },

    async getFinance() {
      try {
        const response = await this.getClientFinances(this.clientID);
        this.finances = response
      } catch (error) {
        console.log(error)
      } 
    },

    async deleteFinance(id) {
      let confirmDeletion = confirm(
        "Are you sure you want to delete this finance?"
      );
      if (confirmDeletion) {
        try {
          let response = await this.deleteItem(id);
          this.msg = true;
          this.text = response.message;
        } catch (error) {
          console.log(error);
        }
      }
    },

    closeOut(id) {
      this.financeID = id;
      this.$store.dispatch("finances/setCloseOutDialog", true);
    },
  },
};
</script>
<style>
.Red {
  background-color: #ffebee;
}

.Green {
  background-color: #e8f5e9;
}
@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }
}

.balance-amount {
  font-size: 40px;
}

.balance-amount--current {
  font-size: 20px;
}
</style>
